import { S } from '@/shared/constants/styles';

export default function HouseholdSelector({
  user,
  householdMode,
  setHouseholdMode,
  householdError,
  newHouseholdName,
  setNewHouseholdName,
  joinCode,
  setJoinCode,
  setupLoading,
  onCreateHousehold,
  onJoinHousehold,
  onLogout,
}) {
  const ss = {
    container: {
      display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh',
      background: 'linear-gradient(145deg,#0f172a,#1e293b)', fontFamily: 'system-ui,-apple-system,sans-serif',
    },
    card: {
      background: 'white', borderRadius: 20, padding: '44px 36px',
      boxShadow: '0 25px 60px rgba(0,0,0,0.3)', maxWidth: 420, width: '92%',
    },
    err: {
      background: '#fef2f2', color: '#991b1b', border: '1px solid #fecaca',
      borderRadius: 10, padding: '10px 14px', fontSize: 13, marginBottom: 14, textAlign: 'center',
    },
  };
  const fieldLabelStyle = { display: 'block', fontSize: 11, fontWeight: 600, color: '#6b7280', marginBottom: 4 };

  return (
    <div style={ss.container}>
      <div style={ss.card}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <span style={{ fontSize: 44 }}>{'\u{1F3E0}'}</span>
        </div>
        <div style={{ fontSize: 22, fontWeight: 800, color: '#0f172a', textAlign: 'center', marginBottom: 4 }}>
          Set Up Your Household
        </div>
        <div style={{ fontSize: 13, color: '#94a3b8', textAlign: 'center', marginBottom: 28 }}>
          {'Signed in as ' + user.email}
        </div>
        {householdError && <div style={ss.err}>{householdError}</div>}

        {householdMode === 'choose' && (
          <>
            <button onClick={() => setHouseholdMode('create')} style={{ ...S.btn(), width: '100%', padding: 14, borderRadius: 10, marginBottom: 10 }}>
              Create a new household
            </button>
            <button onClick={() => setHouseholdMode('join')} style={{ ...S.btn('#f1f5f9'), width: '100%', padding: 14, borderRadius: 10, color: '#334155', marginBottom: 10 }}>
              Join with an invite code
            </button>
            <button onClick={onLogout} style={{ ...S.link('#94a3b8'), display: 'block', margin: '12px auto', fontSize: 13 }}>
              Sign out
            </button>
          </>
        )}

        {householdMode === 'create' && (
          <>
            <label style={fieldLabelStyle}>Household name</label>
            <input
              value={newHouseholdName}
              onChange={(e) => setNewHouseholdName(e.target.value)}
              placeholder="e.g. Specht-Prates Family"
              style={{ ...S.input, marginBottom: 16 }}
            />
            <button
              onClick={onCreateHousehold}
              disabled={setupLoading}
              style={{ ...S.btn(setupLoading ? '#93c5fd' : '#2563eb'), width: '100%', padding: 13, borderRadius: 10 }}
            >
              {setupLoading ? 'Creating...' : 'Create Household'}
            </button>
            <button onClick={() => setHouseholdMode('choose')} style={{ ...S.link('#94a3b8'), display: 'block', margin: '12px auto' }}>
              Back
            </button>
          </>
        )}

        {householdMode === 'join' && (
          <>
            <label style={fieldLabelStyle}>Invite code from your partner</label>
            <input
              value={joinCode}
              onChange={(e) => setJoinCode(e.target.value)}
              placeholder="BUD-XXXXXX"
              style={{ ...S.input, textAlign: 'center', fontSize: 20, letterSpacing: 3, textTransform: 'uppercase', marginBottom: 16, padding: 14 }}
            />
            <button
              onClick={onJoinHousehold}
              disabled={setupLoading}
              style={{ ...S.btn(setupLoading ? '#93c5fd' : '#2563eb'), width: '100%', padding: 13, borderRadius: 10 }}
            >
              {setupLoading ? 'Joining...' : 'Join Household'}
            </button>
            <button onClick={() => setHouseholdMode('choose')} style={{ ...S.link('#94a3b8'), display: 'block', margin: '12px auto' }}>
              Back
            </button>
          </>
        )}
      </div>
    </div>
  );
}
